import { render } from "./PublicationCover.vue?vue&type=template&id=f3c534fa&scoped=true"
import script from "./PublicationCover.vue?vue&type=script&lang=js"
export * from "./PublicationCover.vue?vue&type=script&lang=js"

import "./PublicationCover.vue?vue&type=style&index=0&id=f3c534fa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3c534fa"]])

export default __exports__